import React, {useEffect} from 'react';
import css from './Section.module.scss';
import {useLocation} from 'react-router';
import {SETUP_STEP_TYPES} from '../../../setupSteps/SetupStepTypes';

export const Section: React.FC<{
  type?: SETUP_STEP_TYPES;
  children?: React.ReactNode;
}> = ({type, children}) => {
  const ref = React.useRef<HTMLDivElement>(null);
  const location = useLocation();
  if (type && !location.search.includes(type)) {
    return <></>;
  }

  return (
    <div className={css.root} ref={ref}>
      {children}
    </div>
  );
};
